import {Injectable} from '@angular/core';


@Injectable()
export class GameSetUpService {


    public gameMode: string = 'X01';
    public points: number = 601;
    public sets: number = 1;
    public legs: number = 3;
    public throws: number = 3;
    public countUpRounds: number = 5;

    public teamCount: number = 2;
    public teams: any = [
        {
            name: null,
            id: 0,
            handicap: null,
            finishing: 'straightOut'
        },
        {
            name: null,
            id: 1,
            handicap: null,
            finishing: 'straightOut'
        },
        {
            name: null,
            id: 2,
            handicap: null,
            finishing: 'straightOut'
        },
        {
            name: null,
            id: 3,
            handicap: null,
            finishing: 'straightOut'
        }
    ];

    public eventMode = true;
    public predefinedSetUp = {
        points: 501,
        sets: 1,
        legs: 1,
        countUpRounds: 5,
        teamCount: 2
    };

    constructor() {
        this.loadPredefinedSetUp();
    }

    setGameBySetUpData(setUpData) {
        this.gameMode = setUpData.gameMode;
        this.points = setUpData.points;
        this.sets = setUpData.sets;
        this.legs = setUpData.legs;
        this.throws = setUpData.throws;
        this.countUpRounds = setUpData.countUpRounds;
    }


    public savePredefinedSetUp() {
        localStorage.setItem('predefinedSetUp', JSON.stringify(this.predefinedSetUp));
    }

    public loadPredefinedSetUp() {
        let data = localStorage.getItem('predefinedSetUp');
        if (data !== null) {
            this.predefinedSetUp = JSON.parse(data);
        } else {
            console.log('no predefined setup data');
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/providers/gameSetUp.service.ts